import PrepareFourthContainer from "containers/FuneralPrepareContainer/PrepareFourthContainer";

export default PrepareFourthContainer;
